module.exports = __webpack_public_path__ + "img/third-place.27156365.svg";